(function () {
  'use strict';

  const dataElement = document.getElementById('bundle-validation-data');
  if (!dataElement) return;

  let productData;

  try {
    productData = JSON.parse(dataElement.textContent);
  } catch (error) {
    console.warn('Bundle validation data could not be read.');
    return;
  }

  const variants = productData.variants || [];

  function getBundleQuantity(text) {
    const value = String(text || '');

    let match = value.match(
      /\b(\d+)\s*(?:mice|mouse|pieces?|pcs?)\b/i
    );

    if (!match) {
      match = value.match(
        /\b(?:pack|bundle|set)\s*(?:of\s*)?(\d+)\b/i
      );
    }

    return match ? Number(match[1]) : null;
  }

  function getVariantText(variant) {
    return [
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3
    ].filter(Boolean).join(' ');
  }

  /*
   * Automatically uses the variant containing
   * "1 mouse", "1 mice", "1 piece", etc.
   */
  const masterVariant = variants.find(function (variant) {
    return getBundleQuantity(getVariantText(variant)) === 1;
  });

  if (!masterVariant) {
    console.warn(
      'Bundle validation could not find the 1-mouse master variant.'
    );
    return;
  }

  const masterStock = Number(masterVariant.inventory_quantity);

  if (!Number.isFinite(masterStock)) {
    console.warn(
      'Bundle validation could not read the master variant inventory.'
    );
    return;
  }

  function getProductForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getLabel(control, form) {
    if (control.id) {
      const label = form.querySelector(
        'label[for="' + CSS.escape(control.id) + '"]'
      );

      if (label) return label;
    }

    return control.closest('label');
  }

  function addRedX(label) {
    if (!label) return;

    if (!label.querySelector('.bundle-stock-x')) {
      const mark = document.createElement('span');
      mark.className = 'bundle-stock-x';
      mark.textContent = ' ×';
      mark.setAttribute('aria-hidden', 'true');
      label.appendChild(mark);
    }
  }

  function removeRedX(label) {
    if (!label) return;

    const mark = label.querySelector('.bundle-stock-x');
    if (mark) mark.remove();
  }

  function markRadio(control, quantity, form) {
    const label = getLabel(control, form);
    const unavailable = quantity > masterStock;

    control.disabled = unavailable;
    control.dataset.bundleUnavailable = unavailable
      ? 'true'
      : 'false';

    if (label) {
      label.classList.toggle(
        'bundle-stock-unavailable',
        unavailable
      );

      label.setAttribute(
        'aria-disabled',
        unavailable ? 'true' : 'false'
      );

      if (unavailable) {
        addRedX(label);
      } else {
        removeRedX(label);
      }
    }

    /*
     * If inventory changes and the currently selected option
     * becomes unavailable, select the first available option.
     */
    if (unavailable && control.checked) {
      control.checked = false;

      const alternatives = Array.from(
        form.querySelectorAll('input[type="radio"]')
      ).filter(function (radio) {
        return (
          radio.name === control.name &&
          radio.dataset.bundleUnavailable !== 'true'
        );
      });

      if (alternatives[0]) {
        alternatives[0].click();
      }
    }
  }

  function markSelect(select) {
    let unavailableOptionFound = false;

    Array.from(select.options).forEach(function (option) {
      if (!option.dataset.bundleOriginalText) {
        option.dataset.bundleOriginalText = option.textContent;
      }

      const quantity = getBundleQuantity(
        option.dataset.bundleOriginalText
      );

      if (!quantity) return;

      const unavailable = quantity > masterStock;
      option.disabled = unavailable;

      if (unavailable) {
        unavailableOptionFound = true;
        option.textContent =
          option.dataset.bundleOriginalText + ' ×';
      } else {
        option.textContent =
          option.dataset.bundleOriginalText;
      }
    });

    let status = select.parentElement.querySelector(
      '.bundle-stock-select-status'
    );

    if (unavailableOptionFound) {
      if (!status) {
        status = document.createElement('span');
        status.className = 'bundle-stock-select-status';
        select.insertAdjacentElement('afterend', status);
      }

      status.textContent =
        ' × Some bundle sizes are unavailable';
    } else if (status) {
      status.remove();
    }

    const selectedOption = select.options[select.selectedIndex];

    if (
      selectedOption &&
      selectedOption.disabled
    ) {
      const firstAvailable = Array.from(select.options).find(
        function (option) {
          return !option.disabled && option.value;
        }
      );

      if (firstAvailable) {
        select.value = firstAvailable.value;
        select.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
    }
  }

  function updateBundleOptions() {
    const form = getProductForm();
    if (!form) return;

    const controls = form.querySelectorAll(
      'input[type="radio"], select, [role="radio"], button'
    );

    controls.forEach(function (control) {
      if (control.matches('select')) {
        markSelect(control);
        return;
      }

      const label = getLabel(control, form);
      const text = label
        ? label.textContent
        : control.textContent;

      const quantity = getBundleQuantity(text);

      if (!quantity) return;

      if (control.matches('input[type="radio"]')) {
        markRadio(control, quantity, form);
        return;
      }

      const unavailable = quantity > masterStock;

      control.disabled = unavailable;
      control.dataset.bundleUnavailable = unavailable
        ? 'true'
        : 'false';

      control.classList.toggle(
        'bundle-stock-unavailable',
        unavailable
      );

      if (unavailable) {
        addRedX(control);
      } else {
        removeRedX(control);
      }
    });
  }

  function getSelectedVariant() {
    const form = getProductForm();
    if (!form) return null;

    const variantInput = form.querySelector(
      '[name="id"]'
    );

    if (!variantInput) return null;

    return variants.find(function (variant) {
      return String(variant.id) === String(variantInput.value);
    });
  }

  function validateBeforeAddToCart() {
    const selectedVariant = getSelectedVariant();

    if (!selectedVariant) return true;

    const quantity = getBundleQuantity(
      getVariantText(selectedVariant)
    );

    if (!quantity || quantity <= masterStock) {
      return true;
    }

    alert(
      'This bundle is unavailable because only ' +
      masterStock +
      ' mouse' +
      (masterStock === 1 ? '' : 's') +
      ' remain in stock.'
    );

    return false;
  }

  function initialise() {
    const form = getProductForm();
    if (!form) return;

    updateBundleOptions();

    if (form.dataset.bundleValidationReady === 'true') {
      return;
    }

    form.dataset.bundleValidationReady = 'true';

    form.addEventListener('change', function () {
      window.setTimeout(updateBundleOptions, 50);
    }, true);

    form.addEventListener('click', function (event) {
      const control = event.target.closest(
        'input[type="radio"], button, [role="radio"]'
      );

      if (
        control &&
        control.dataset.bundleUnavailable === 'true'
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const submitButton = event.target.closest(
        'button[type="submit"], input[type="submit"]'
      );

      if (submitButton && !validateBeforeAddToCart()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    form.addEventListener('submit', function (event) {
      if (!validateBeforeAddToCart()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  const style = document.createElement('style');

  style.textContent = `
    .bundle-stock-unavailable {
      opacity: 0.45 !important;
      cursor: not-allowed !important;
    }

    .bundle-stock-x {
      color: #c62828;
      font-size: 1.2em;
      font-weight: 700;
      margin-left: 4px;
    }

    .bundle-stock-select-status {
      display: block;
      color: #c62828;
      font-size: 0.9em;
      margin-top: 6px;
    }
  `;

  document.head.appendChild(style);

  initialise();

  document.addEventListener(
    'shopify:section:load',
    initialise
  );
})();
